import styled from 'styled-components';
import { COLORS, FONT_FAMILY, DEVICES } from '@Commons';

export const Title = styled.div`
  font-size: 18px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
  text-align: center;
  line-height: 26px;
`;

export const SubTitle = styled.div`
  text-align: center;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
  line-height: 22px;
  font-size: 16px;
`;

interface IModalContainerProps {
  gap?: string;
}

export const ModalContainer = styled.div<IModalContainerProps>`
  position: relative;
  width: 500px;
  padding: 32px 24px;
  display: flex;
  margin: 14px;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  gap: ${({ gap }) => gap || '0px'};
  background-color: ${COLORS.white};
  @media ${DEVICES.mobileXL} {
    width: 100%;
  }
`;
